<template>
	<div>
		<vs-table stripe :data ="requests">
			<template slot="header">
				<h3>
					Account aanvragen
				</h3>
			</template>
			<template slot="thead">
				<vs-th>
					Bedrijf
				</vs-th>
				<vs-th>
					Contact
				</vs-th>
				<vs-th>
					Email
				</vs-th>
				<vs-th>
					Acties
				</vs-th>
			</template>

			<template>
				<vs-tr :key="request.id" v-for="request in requests" >
					<vs-td >
						{{request.company}}
					</vs-td>

					<vs-td>
						{{request.salution}} {{request.initials}} {{request.last_name}}
					</vs-td>

					<vs-td>
						{{request.email}}
					</vs-td>

					<vs-td>
						<vs-button class="mr-3 mb-2" @click="approve(request.id)" color="success">Accepteren</vs-button>
						<vs-button class="mr-3 mb-2" @click="decline(request.id)" color="danger">Weigeren</vs-button>
					</vs-td>
				</vs-tr>
			</template>
		</vs-table>
	</div>
</template>
<script>
	import api from '../api';
	export default {
		name: 'Dashboard',
		components: {},
		props: {},
		data () {
			return {
				requests: []
			}
		},
		computed: {

		},
		mounted () {
			this.getRequests();
		},
		methods: {
			getRequests(){
				api.get("admin/requests").then(response=>{
					console.log(response);
					this.requests = response.data.data;
				}).catch((error)=>{
					console.log(error);
				})
			},
			approve(id){
				api.get("admin/requests/"+id+"/approve").then(response=>{
					if(response.data.error){
						console.log(response);

						this.$vs.notify({
							title:'Error',
							text:response.data.message,
							color:'danger'});
					}
					else{
						this.$vs.notify({
							title:'Goedgekeurd!',
							text:"Request is goedgekeurd",
							color:'success'
						});
						console.log(response);
						this.getRequests();
					}
				}).catch((error)=>{
					console.log(error);
				})
			},
			decline(id){
				api.get("admin/requests/"+id+"/decline").then(response=>{
					this.$vs.notify({
						title:'Geweigerd',
						text:"De request is succesvol geweigerd",
						color:'success'});
					console.log(response);
					this.getRequests();
				}).catch((error)=>{
					console.log(error);
				})
			}
		}
	}

</script>
